module.exports = __webpack_public_path__ + "static/img/loader_img.d47e58c.gif";